export enum AUTO_ACCEPT_ODDS_CHANGE {
  NO,
  YES,
}

export enum SHOW_TOTAL_STAKES_TOGGLE {
  OFF,
  ON,
}

export enum SortType {
  SORT_BY_START_DATE = 0,
  SORT_BY_BET_PLACED = 1,
}

export enum SportBetType {
  ACTIVE = 'active',
  SETTLED = 'settled',
}

export enum BetSlipTab {
  SINGLE = 'single',
  MULTIPLES = 'multiples',
}

export enum SIDE_BAR_TABS {
  BET_SLIP = 'Bet Slip',
  MY_BETS = 'My Bets',
}

export enum SYSTEM_BET_TYPE {
  ACCA = 'Acca',
  SINGLES = 'Singles',
  DOUBLES = 'Doubles',
  TREBLES = 'Trebles',
  FOLDS_4 = '4-folds',
  FOLDS_5 = '5-folds',
  FOLDS_6 = '6-folds',
  TRIXIE = 'Trixie',
  PATENT = 'Patent',
  YANKEE = 'Yankee',
  LUCKY_15 = 'Lucky 15',
  SUPER_YANKEE = 'Super Yankee',
  LUCKY_31 = 'Lucky 31',
  HEINZ = 'Heinz',
  LUCKY_63 = 'Lucky 63',
  ANGEL = 'Angel',
}

export enum SYSTEM_BET_TYPE_DESCRIPTION {
  SINGLES = 'A single consists of 1 bet involving 1 selection in an event. The selection must be successful to get a return. You could be Supercharged on each single bet :rocket:',
  DOUBLES = 'A Double consists of 1 bet involving 2 selections in different events. Both must be successful to get a return. You could be Supercharged on each double bet :rocket:',
  TREBLES = 'A Treble consists of 1 bet involving 3 selections in different events. All must be successful to get a return. You could be Supercharged on each treble bet :rocket:',
  FOLDS_4 = 'A Four-Fold Accumulator consists of 1 bet involving 4 selections in different events. All must be successful to get a return. You could be Supercharged on each 4 fold bet :rocket:',
  FOLDS_5 = 'A Five-Fold Accumulator consists of 1 bet involving 5 selections in different events. All must be successful to get a return. You could be Supercharged on each 5 fold bet :rocket:',
  FOLDS_6 = 'A Six-Fold Accumulator consists of 1 bet involving 6 selections in different events. All must be successful to get a return. You could be Supercharged on each 6 fold bet :rocket:',
  TRIXIE = 'A Trixie consists of 4 bets involving 3 selections in different events, i.e. 3 doubles plus 1 treble. A minimum of 2 of your selections must be successful to get a return. You could be Supercharged on each of the 4 bets in your Trixie :rocket:',
  PATENT = 'A Patent consists of 7 bets involving 3 selections in different events, ie. 3 singles, 3 doubles, and 1 Treble. Just one successful selection guarantees a return. You could be Supercharged on each of the 7 bets in your Patent :rocket:',
  YANKEE = 'A Yankee consists of 11 bets involving 4 selections in different events, i.e. 6 doubles, 4 trebles and 1 four-fold. A minimum of 2 of your selections must be successful to get a return. You could be Supercharged on each of the 11 bets in your Yankee :rocket:',
  LUCKY_15 = 'A Lucky 15 consists of 15 bets involving 4 selections in different events, i.e. 4 singles, 6 doubles, 4 trebles and 1 four-fold. Just one successful selection guarantees a return. You could be Supercharged on each of the 15 bets in your Lucky 15 :rocket:',
  SUPER_YANKEE = 'A Super Yankee (also known as a Canadian) consists of 26 bets involving 5 selections in different events, i.e. 10 doubles, 10 trebles, 5 four-folds plus 1 five-fold. A minimum of 2 of your selections must be successful to get a return. You could be Supercharged on each of the 26 bets in your Super Yankee :rocket:',
  LUCKY_31 = 'A Lucky 31 consists of 31 bets involving 5 selections in different events, i.e. 5 singles, 10 doubles, 10 trebles, 5 four-folds and 1 five-fold. Just one successful selection guarantees a return.You could be Supercharged on each of the 31 bets in your Lucky 31 :rocket:',
  HEINZ = 'A Heinz consists of 57 bets involving 6 selections in different events, i.e. 15 doubles, 20 trebles, 15 four-folds, 6 five-folds and 1 six-fold. A minimum of 2 of your selections must be successful to get a return. You could be Supercharged on each of the 57 bets in your Heinz :rocket:',
  LUCKY_63 = 'A Lucky 63 consists of 63 bets involving 6 selections in different events, i.e. 6 singles, 15 doubles, 20 trebles, 15 four-folds, 6 five-folds and 1 six-fold. Just one successful selection guarantees a return. You could be Supercharged on each of the 63 bets in your Lucky 63 :rocket:',
  ANGEL = 'An Angel consists of 3 bets involving 2 selections in different events, i.e. 1 double plus 2 singles. Just one successful selection guarantees a return. You could be Supercharged on each of the 3 bets in your Angel :rocket:',
}

export enum SYSTEM_BET_ENVELOPE_TEXT_DISPLAY_DELAY {
  ENVELOPE_1 = 2000,
  ENVELOPE_2 = 3500,
}

export enum SYSTEM_BET_ENVELOPE_SUMMARY_DISPLAY_DELAY {
  GOLD = 3000,
  SILVER = 3200,
  BRONZE = 3400,
}

export enum BET_PLACE_ANIMATION_STEP {
  STAY = 'STAY',
  LAUNCH = 'LAUNCH',
}
